import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
import { FileStatus } from './file-status';
export var File = /*#__PURE__*/function (_Entity) {
  _inherits(File, _Entity);

  var _super = _createSuper(File);

  function File() {
    _classCallCheck(this, File);

    return _super.apply(this, arguments);
  }

  _createClass(File, [{
    key: "status",
    get: function get() {
      return this.props.status;
    }
  }, {
    key: "url",
    get: function get() {
      return this.props.url;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "size",
    get: function get() {
      return this.props.size;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return {
        id: this.id.toString(),
        url: this.url,
        type: this.type,
        size: this.size
      };
    }
  }], [{
    key: "create",
    value: function create(props, id) {
      var _props$status;

      var guardCollections = [{
        argument: props.url,
        argumentName: 'Signed Url'
      }, {
        argument: props.size,
        argumentName: 'Size'
      }, {
        argument: props.type,
        argumentName: 'Type'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Error');
      }

      var defaultProps = _objectSpread(_objectSpread({}, props), {}, {
        status: (_props$status = props.status) !== null && _props$status !== void 0 ? _props$status : FileStatus.Saved
      });

      return Result.ok(new File(defaultProps, new UniqueEntityID(id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      var id = data.id,
          url = data.url,
          type = data.type,
          size = data.size;
      return this.create({
        url: url,
        type: type,
        size: size
      }, id);
    }
  }]);

  return File;
}(Entity);